var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.twMerge('editor flex h-full flex-col', _setup.toolbarStyle, _vm.twClass)},[_c('div',{ref:"editor",staticClass:"quill-editor min-h-0",class:_setup.editorStyle,on:{"dragend":function($event){$event.preventDefault();},"drop":function($event){$event.preventDefault();}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }